import { render, staticRenderFns } from "./MicrochipCertificatePopup.vue?vue&type=template&id=cfbf6942&scoped=true&"
import script from "./MicrochipCertificatePopup.vue?vue&type=script&lang=js&"
export * from "./MicrochipCertificatePopup.vue?vue&type=script&lang=js&"
import style0 from "./MicrochipCertificatePopup.vue?vue&type=style&index=0&id=cfbf6942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbf6942",
  null
  
)

export default component.exports